export const BUG_REPORT_CATEGORIES = [
  { value: "alert_clip_did_not_load", label: "Alert clip did not load" },
  { value: "livestream_did_not_load", label: "Livestream did not load" },
  { value: "alert_and_livestream_did_not_load", label: "Alert and livestream did not load" },
  { value: "elapsed_time_issue", label: "Elapsed time issue" },
  { value: "alerting_out_of_schedule", label: "Alerting out of schedule" },
  { value: "audio_issue", label: "Audio issue" },
  { value: "map_issue", label: "Map issue" },
  { value: "tagging_issue", label: "Tagging issue" },
  { value: "zone_issue", label: "Zone issue" },
  { value: "fov_duplicated_view_issue", label: "FOV/duplicated view issue" },
  { value: "general_other", label: "General/Other" },
] as const;

export type BugReportCategoryValue = typeof BUG_REPORT_CATEGORIES[number]["value"];
export const BUG_REPORT_CATEGORY_VALUES = BUG_REPORT_CATEGORIES.map(c => c.value);

/** Categories 1-3: description is NOT required */
export const CATEGORIES_WITHOUT_DESCRIPTION_REQUIRED: BugReportCategoryValue[] = [
  "alert_clip_did_not_load",
  "livestream_did_not_load",
  "alert_and_livestream_did_not_load",
];
